<template>
  <TransferRates />
</template>
<script>
import TransferRates from "@/components/master/transferTariff/TransferRates.vue";
export default {
  components: {
    TransferRates,
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("buying-transfer-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/buyingTariff/TransferRateList.vue